import React from 'react';
import DataTable from '../reporting_utils/DataTable';

const $ = window.$;

/**
 * @param {{ data: any[], industryType: string }} props
 */
export default function LocationBreakdownTable({ data, industryType }) {
  function buildColumnDefs() {
    /** @type {import('../reporting_utils/DataTable').ColumnDef[]} */
    const columns = [];
    columns.push({
      title: 'Location',
      data: 'location_name',
    });
    columns.push({
      title: 'Referral',
      data: 'ref_medium',
    });
    columns.push({
      title: 'Texts',
      data: 'texts',
      render: $.fn.dataTable.render.number(','),
      aggregation: 'sum',
    });
    columns.push({
      title: 'WebForms',
      data: 'leads',
      render: $.fn.dataTable.render.number(','),
      aggregation: 'sum',
    });
    columns.push({
      title: 'Chats',
      data: 'chats',
      render: $.fn.dataTable.render.number(','),
      aggregation: 'sum',
    });
    columns.push({
      title: 'Calls',
      data: 'calls',
      render: $.fn.dataTable.render.number(','),
      aggregation: 'sum',
    });
    if (
      industryType === 'Automotive' ||
      industryType === 'Other' ||
      industryType === 'Home Improvement'
    ) {
      columns.push({
        title: 'Sales',
        data: 'sales',
        render: $.fn.dataTable.render.number(','),
        aggregation: 'sum',
      });
    }
    if (industryType === 'Automotive' || industryType === 'Home Improvement') {
      columns.push({
        title: 'Service',
        data: 'service',
        render: $.fn.dataTable.render.number(','),
        aggregation: 'sum',
      });
    }
    if (industryType === 'Automotive') {
      columns.push({
        title: 'Parts',
        data: 'parts',
        render: $.fn.dataTable.render.number(','),
        aggregation: 'sum',
      });
    }
    columns.push({
      title: 'Appointments',
      data: 'appts',
      render: $.fn.dataTable.render.number(','),
      aggregation: 'sum',
    });
    columns.push({
      title: 'No Appts',
      data: 'noappts',
      render: $.fn.dataTable.render.number(','),
      aggregation: 'sum',
    });
    if (industryType === 'Other') {
      columns.push({
        title: 'Current Customer',
        data: 'current_customer',
        render: $.fn.dataTable.render.number(','),
        aggregation: 'sum',
      });
    }
    if (industryType === 'Other') {
      columns.push({
        title: 'General Business',
        data: 'general_business',
        render: $.fn.dataTable.render.number(','),
        aggregation: 'sum',
      });
    }
    columns.push({
      title: 'Hang Ups',
      data: 'hang_ups',
      render: $.fn.dataTable.render.number(','),
      aggregation: 'sum',
    });
    if (industryType === 'Healthcare') {
      columns.push({
        title: 'Maintenance',
        data: 'maintenance',
        render: $.fn.dataTable.render.number(','),
        aggregation: 'sum',
      });
    }
    if (industryType === 'Healthcare') {
      columns.push({
        title: 'Prospect',
        data: 'prospect',
        render: $.fn.dataTable.render.number(','),
        aggregation: 'sum',
      });
    }
    if (industryType === 'Pest') {
      columns.push({
        title: 'One Time Service',
        data: 'one_time_service',
        render: $.fn.dataTable.render.number(','),
        aggregation: 'sum',
      });
    }
    if (industryType === 'Pest') {
      columns.push({
        title: 'Recurring Service',
        data: 'recurring_service',
        render: $.fn.dataTable.render.number(','),
        aggregation: 'sum',
      });
    }
    columns.push({
      title: 'Missed Opps',
      data: 'missedops',
      render: $.fn.dataTable.render.number(','),
      aggregation: 'sum',
    });
    columns.push({
      title: 'Appointment Conversion',
      data: 'appt_conversion',
      
      className: 'table_percent_bar',
      render(data) {
        if (data) {
          return `
            <div class='bar_label'>${data}%</div>
            <div style='position:relative;' class='bar'>
              <div style='width:${data}%;' class='bar_filler'></div>
            </div>`;
        } else {
          return null;
        }
      },
    });

    return columns;
  }

  return (
    <div className='row row_spacer'>
      <div className='col-xs-12'>
        <div className='report_data_container'>
          <div className='title'>Location Breakdown</div>
          <DataTable
            columnDefs={buildColumnDefs()}
            data={data}
            showTotalFooter={true}
            title='Location Breakdown'
            order={[[5, 'desc']]}
          />
        </div>
      </div>
    </div>
  );
}
